import { render, staticRenderFns } from "./ConnectorsTable.vue?vue&type=template&id=60d1f766&scoped=true"
import script from "./ConnectorsTable.vue?vue&type=script&lang=ts"
export * from "./ConnectorsTable.vue?vue&type=script&lang=ts"
import style0 from "./ConnectorsTable.vue?vue&type=style&index=0&id=60d1f766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1f766",
  null
  
)

export default component.exports